import { compose, propEq, find } from 'ramda'

export const getUpgradePopupConcurrentTitle = compose(
  option => option.value,
  find(propEq('key', 'BASIC_SUBS_POPUP_CONCURRENT_TITLE'))
)
